import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function Articles() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Dive into a world of premium travel with our collection of airline articles on First-Class.com. Explore insights, reviews, and travel stories'
          }
        />
        <title>Airline Articles: In-Depth Insights and Analysis</title>
      </Head>
      <ArticlesList subtype="Articles" type="Airlines" />
    </>
  );
}

export default withLayout(Articles, true);
